<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name:'app',
  created() {
    const furl = window.location.href;
    if (furl.indexOf("happycode.xyz") > -1) {
      window.location.href = furl.replace(/pagesart/g, "hsj");
      return;
    }
    document
      .querySelector("link[rel=icon]")
      .setAttribute("href", "//cdn.huashijie.art/common/panda.ico");
  }
}
</script>

<style></style>
